import { theme } from '@lua-frontend/numu-ui';
import React, { Component } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';


class SelectAsyncPaginate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: '',
      dropdownOptions: [],
      dropdownTotalCount: 0,
    };
    this.extendedLoadOptions = this.extendedLoadOptions.bind(this);
    this.searchFtn = this.searchFtn.bind(this);
  }
  extendedLoadOptions = async (search, prevOptions) => {
    if (!search) {
      const { data, totalCount } = await this.props.loadMoreOptions(
        Math.floor(prevOptions.length / this.props.limit + this.props.initPage)
      );
      let hasMore = totalCount > prevOptions.length + data.length;
      let options = data;
      return {
        options,
        hasMore,
      };
    } else {
      clearTimeout(this.timer);
      const myPromise = new Promise((resolve, reject) => {
        this.timer = setTimeout(async () => {
          let result;
          result = await this.searchFtn(search, prevOptions);
          resolve(result);
        }, 800);
      });
      const results = await myPromise.then(({ options, hasMore }) => {
        return {
          options,
          hasMore,
        };
      });
      return results;
    }
  };

  searchFtn = async (search, prevOptions) => {
    const { data, totalCount } = await this.props.onSearch(search, prevOptions);
    return {
      options: data,
      hasMore: totalCount > prevOptions.length + data.length,
    };
  };

  render() {
    const {
      value,
      options,
      onChange,
      loading,
      disabled,
      onSearch,
      isMulti = false,
      placeholder = 'Select ... ',
      closeMenuOnSelect = true,
      selectStyles = {},
      componentKey,
      ...rest
    } = this.props;

    const styles = {
      ...selectStyles,
      menu: (provided) => {
        return {...provided,
        ...selectStyles.menu,
        zIndex: 9999}
      },
      option: (provided, {isFocused, isSelected }) =>  {
        return {...provided,
          ...selectStyles?.option,
          ...((isSelected ) && {
            color: 'white',
          }),
          ...((isFocused && !isSelected)  && {
            backgroundColor: '#E6F4FF !important' ,
          })
        }
      }

    };
    
    return (
      <AsyncPaginate
        {...rest}
        key = {componentKey}
        isLoading={loading}
        isDisabled={disabled}
        value={value}
        loadOptions={this.extendedLoadOptions}
        isMulti={isMulti}
        closeMenuOnSelect={closeMenuOnSelect}
        onChange={onChange}
        placeholder={placeholder}
        //Deprecated 22 april 2026 to resolve z-index issue on country and city filters
        // styles = {theme.styles.selectWithInput()}
        styles={theme.styles.selectWithInput(false, selectStyles)}
        menuPlacement="auto"

      />
    );
  }
}

export { SelectAsyncPaginate };

